import { Box } from "@chakra-ui/react/box"

interface WorkThumbnailFallbackProps {
  index: number
}

const WorkThumbnailFallback = ({ index }: WorkThumbnailFallbackProps) => {
  const variant = index % 3
  const background =
    variant === 0
      ? "linear-gradient(135deg, #042c53 0%, #185fa5 100%)"
      : variant === 1
        ? "#f1efe8"
        : "#ffffff"

  return (
    <Box
      aria-hidden="true"
      bg={background}
      h="full"
      position="relative"
      w="full"
    >
      {variant === 1 && (
        <>
          <Box
            as="span"
            bg="#2c2c2a"
            borderRadius="0.125rem"
            display="block"
            h="0.5rem"
            left="0.875rem"
            position="absolute"
            right="0.875rem"
            top="0.875rem"
          />
          <Box
            as="span"
            bg="#888780"
            borderRadius="0.125rem"
            display="block"
            h="0.25rem"
            left="0.875rem"
            position="absolute"
            top="1.75rem"
            w="3.125rem"
          />
          <Box
            as="span"
            bg="#2c2c2a"
            borderRadius="0.25rem"
            bottom="0.875rem"
            color="#f1efe8"
            fontSize="0.5625rem"
            fontWeight="500"
            left="0.875rem"
            lineHeight="1.2"
            position="absolute"
            px="0.5rem"
            py="0.25rem"
          >
            AAA
          </Box>
        </>
      )}
      {variant === 2 && (
        <>
          <Box
            as="span"
            bg="#1d70b8"
            borderRadius="0.25rem"
            color="#ffffff"
            fontSize="0.5625rem"
            fontWeight="500"
            left="0.75rem"
            lineHeight="1.2"
            position="absolute"
            px="0.5rem"
            py="0.25rem"
            top="0.75rem"
          >
            GOV.UK
          </Box>
          <Box
            as="span"
            bg="#0b0c0c"
            borderRadius="0.125rem"
            display="block"
            h="0.1875rem"
            left="0.75rem"
            position="absolute"
            right="0.75rem"
            top="2rem"
          />
          <Box
            as="span"
            bg="#00703c"
            borderRadius="0.25rem"
            bottom="0.875rem"
            color="#ffffff"
            fontSize="0.5625rem"
            fontWeight="500"
            left="0.875rem"
            lineHeight="1.2"
            position="absolute"
            px="0.5rem"
            py="0.25rem"
          >
            Continue
          </Box>
        </>
      )}
      {variant === 0 && (
        <>
          <Box
            as="span"
            borderColor="rgb(255 255 255 / 0.3)"
            borderRadius="0.25rem"
            borderWidth="1px"
            inset="0.75rem"
            position="absolute"
          />
          <Box
            as="span"
            bg="rgb(255 255 255 / 0.6)"
            borderRadius="999px"
            display="block"
            h="0.25rem"
            left="1.125rem"
            position="absolute"
            top="1.125rem"
            w="1.75rem"
          />
          <Box
            as="span"
            borderColor="rgb(255 255 255 / 0.5)"
            borderRadius="999px"
            borderWidth="1px"
            bottom="0.875rem"
            h="1.5rem"
            position="absolute"
            right="0.875rem"
            w="1.5rem"
          />
        </>
      )}
    </Box>
  )
}

export { WorkThumbnailFallback }
export default WorkThumbnailFallback
